import React, { useContext, useEffect, useState } from "react";
import { PitchContext } from "../context/PitchContex";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import { BsThreeDots } from "react-icons/bs";
import Spinner from "../components/Spinner";
import AccessDenied from "../components/AccessDenied";
import { FiSearch } from "react-icons/fi";

const AdminPitchBookings = () => {
  const { slug } = useParams();
  const { user, backendURL, token } = useContext(PitchContext);
  const [pitch, setPitch] = useState();
  const [search, setSearch] = useState("");
  const [pitchBookings, setPitchBookings] = useState([]);
  const [filteredBookings, setFilteredBookings] = useState([]);
  const [showMenu, setShowMenu] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [openDate, setOpenDate] = useState(null);
  const itemsPerPage = 30;

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentBookings = filteredBookings.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const totalPages = Math.ceil(filteredBookings.length / itemsPerPage);

  function capitalizeWordTurkish(str) {
    if (!str || typeof str !== "string") return "";
    const firstChar = str.charAt(0);
    const rest = str.slice(1);
    const turkishMap = {
      i: "İ",
      ı: "I",
      u: "U",
      ü: "Ü",
      o: "O",
      ö: "Ö",
      s: "S",
      ş: "Ş",
      c: "C",
      ç: "Ç",
      g: "G",
      ğ: "Ğ",
    };
    const upperFirst =
      turkishMap[firstChar] || firstChar.toLocaleUpperCase("tr-TR");
    const lowerRest = rest.toLocaleLowerCase("tr-TR");
    return upperFirst + lowerRest;
  }

  const handleSearchChange = (e) => {
    const value = capitalizeWordTurkish(e.target.value);
    setSearch(value);
    setCurrentPage(1);

    if (value) {
      const filtered = pitchBookings.filter((item) =>
        item.userID.fullname
          .toLocaleLowerCase()
          .includes(value.toLocaleLowerCase())
      );
      setFilteredBookings(filtered);
    } else {
      setFilteredBookings(pitchBookings);
    }
  };

  const getPitch = () => {
    axios
      .post(
        backendURL + `pitch/get/${slug}`,
        { userID: user._id },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((response) => {
        if (response.data.success) {
          setPitch(response.data.pitch);
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(err.response?.data?.message || "Error fetching pitch");
      });
  };

  useEffect(() => {
    if (!token) {
      return;
    }
    if (user.role !== "admin") {
      return;
    }
    getPitch();
  }, []);

  useEffect(() => {
    if (pitch) {
      const temp = pitch.bookings.slice();
      setPitchBookings(
        temp.sort(
          (a, b) =>
            new Date(b.bookingData.dateTime) - new Date(a.bookingData.dateTime)
        )
      );
    }
  }, [pitch]);

  useEffect(() => {
    setFilteredBookings(pitchBookings);
  }, [pitchBookings]);

  const deleteBooking = (bookingID) => {
    axios
      .post(
        backendURL + `booking/remove-pitch`,
        { userID: user._id, pitchID: pitch._id, bookingID },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((response) => {
        if (response.data.success) {
          setPitchBookings((prev) =>
            prev.filter((booking) => booking._id !== bookingID)
          );
          setShowMenu(null);
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(err.response?.data?.message || "Error deleting booking");
      });
  };

  const groupBookingsByDate = (bookings) => {
    return bookings.reduce((acc, booking) => {
      const date = new Date(booking.bookingData.dateTime).toLocaleDateString(
        "en-GB"
      );
      if (!acc[date]) acc[date] = [];
      acc[date].push(booking);
      return acc;
    }, {});
  };

  const groupedBookings = groupBookingsByDate(currentBookings);

  const goToPreviousPage = () => {
    window.scrollTo(0, 0);
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const goToNextPage = () => {
    window.scrollTo(0, 0);
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };

  if (!token || user.role !== "admin") {
    return <AccessDenied />;
  }
  if (pitch) {
    if (user.pitches.includes(pitch._id)) {
      return <AccessDenied />;
    }
  }

  if (!pitch) {
    return <Spinner />;
  }

  return (
    <div className="min-h-screen  py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl mx-auto">
        {/* Header Section */}
        <div className="text-center mb-12">
          <h2 className="text-4xl font-extrabold text-gray-900">
            <span className="bg-gradient-to-r from-green-600 to-teal-600 bg-clip-text text-transparent">
              {pitch.name}
            </span>{" "}
            Rezervasyonları
          </h2>
          <p className="mt-3 text-lg text-gray-600">
            Tüm saha rezervasyonlarını kolayca yönetin ve görüntüleyin
          </p>
          {pitchBookings.length !== 0 && (
            <p className="mt-4 text-sm text-gray-500">
              <span className="font-medium text-green-600">Yeşil</span>{" "}
              kenarlılar gelecek tarihli,{" "}
              <span className="font-medium text-red-600">Kırmızı</span>{" "}
              kenarlılar geçmiş tarihli rezervasyonları gösterir.
            </p>
          )}
        </div>

        {/* Search Bar */}
        <div className="relative max-w-md mx-auto mb-12">
          <div className="absolute inset-y-0 left-0 flex items-center pl-3">
            <FiSearch className="h-5 w-5 text-gray-400" />
          </div>
          <input
            type="text"
            placeholder="Kullanıcı adına göre ara..."
            value={search}
            onChange={handleSearchChange}
            className="w-full pl-10 pr-4 py-3 bg-white border border-gray-200 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-300 text-gray-700 placeholder-gray-400"
          />
        </div>

        {/* Bookings Section */}
        {pitchBookings.length === 0 ? (
          <div className="bg-white rounded-2xl shadow-lg p-10 text-center transition-all duration-300">
            <p className="text-lg font-medium text-gray-600">
              Henüz rezervasyon bulunmamaktadır.
            </p>
            <p className="mt-2 text-sm text-gray-400">
              Yeni rezervasyonlar için daha sonra kontrol edin!
            </p>
          </div>
        ) : (
          <div className="space-y-6 ">
            {Object.entries(groupedBookings).map(([dateStr, bookings]) => (
              <div
                key={dateStr}
                className="bg-white rounded-2xl shadow-lg overflow-hidden transition-all duration-300"
              >
                <button
                  onClick={() =>
                    setOpenDate(openDate === dateStr ? null : dateStr)
                  }
                  className="cursor-pointer w-full flex justify-between items-center px-6 py-5 bg-gray-50 hover:bg-gray-100 transition-colors duration-200"
                >
                  <span className="text-lg font-semibold text-gray-800">
                    {dateStr}
                  </span>
                  <span className="text-2xl text-gray-500">
                    {openDate === dateStr ? "−" : "+"}
                  </span>
                </button>

                {openDate === dateStr && (
                  <div className="p-6 space-y-4">
                    {bookings.map((booking) => {
                      const isFuture =
                        new Date(booking.bookingData.dateTime) > new Date();
                      return (
                        <div
                          key={booking._id}
                          className={`relative p-6 rounded-xl bg-gray-50 border-l-4 ${
                            isFuture ? "border-green-500" : "border-red-500"
                          } transition-all duration-300 hover:shadow-md`}
                        >
                          <div className="grid grid-cols-1 md:grid-cols-2">
                            <div className="space-y-2">
                              <div className="flex items-center gap-3">
                                <span className="w-20 font-medium text-gray-600">
                                  İsim:
                                </span>
                                <span className="text-gray-900 ">
                                  {booking.userID.fullname}
                                </span>
                              </div>
                              <div className="flex items-center gap-3">
                                <span className="w-20 font-medium text-gray-600">
                                  Saat:
                                </span>
                                <span className="text-gray-700">
                                  {booking.bookingData.time}
                                </span>
                              </div>
                            </div>
                            <div className="space-y-2">
                              <div className="flex items-center gap-3">
                                <span className="w-20 font-medium text-gray-600">
                                  Telefon:
                                </span>
                                <span className="text-gray-700">
                                  {booking.userID.phone}
                                </span>
                              </div>
                              <div className="space-y-2">
                                <div className="flex items-center gap-3">
                                  <span className="w-30 font-medium text-gray-600">
                                    Alınan Ücret:
                                  </span>
                                  <span className="text-gray-700">
                                    {booking.paymentStatus === "unpaid"
                                      ? "Ödeme Alınmadı"
                                      : `${booking.totalPrice} TL`}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          {booking.userNote && (
                            <div className="mt-4">
                              <span className="font-medium text-gray-600">
                                Not:{" "}
                                <span className="text-gray-800">
                                  {booking.userNote}
                                </span>
                              </span>
                            </div>
                          )}
                          <div className="absolute top-4 right-4">
                            <button
                              onClick={() =>
                                setShowMenu(
                                  showMenu === booking._id ? null : booking._id
                                )
                              }
                              className="text-gray-500 hover:text-gray-800 focus:outline-none transition-colors duration-200"
                            >
                              <BsThreeDots size={22} />
                            </button>
                            {showMenu === booking._id && (
                              <div className="absolute right-0 mt-2 w-36 bg-white rounded-lg shadow-xl z-10 overflow-hidden">
                                <button
                                  onClick={() => deleteBooking(booking._id)}
                                  className="block w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors duration-200"
                                >
                                  Rezervasyonu Sil
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="mt-12 flex justify-center items-center gap-4">
            <button
              onClick={goToPreviousPage}
              disabled={currentPage === 1}
              className="px-5 py-2 bg-white text-gray-700 border border-gray-200 rounded-lg shadow-sm disabled:opacity-50 disabled:cursor-not-allowed hover:bg-green-50 hover:border-green-500 transition-all duration-200"
            >
              Önceki
            </button>
            <span className="text-gray-600 font-medium">
              {currentPage} / {totalPages}
            </span>
            <button
              onClick={goToNextPage}
              disabled={currentPage === totalPages}
              className="px-5 py-2 bg-white text-gray-700 border border-gray-200 rounded-lg shadow-sm disabled:opacity-50 disabled:cursor-not-allowed hover:bg-green-50 hover:border-green-500 transition-all duration-200"
            >
              Sonraki
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminPitchBookings;
